import React, { useState } from "react";
import Spinner from "../components/Spinner";
import {
	getStorage,
	ref,
	uploadBytesResumable,
	getDownloadURL,
} from "firebase/storage";
import { getAuth } from "firebase/auth";
import { toast } from "react-toastify";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { BsCheckLg } from "react-icons/bs";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function CreatePost() {
	const navigate = useNavigate();
	const auth = getAuth();

	const [loading, setLoading] = useState(false);
	const [content, setContent] = useState("");
	const [formData, setFormData] = useState({
		type: "album",
		name: "",
		year: "",
		artist: "",
		rating: "",
		review: "",
		image: {},
	});

	const { type, name, year, artist, rating, image } = formData;

	function onChange(e) {
		let boolean = null;
		if (e.target.value === "true") {
			boolean = true;
		}
		if (e.target.value === "false") {
			boolean = false;
		}
		if (e.target.files) {
			setFormData((prevState) => ({
				...prevState,
				image: e.target.files,
			}));
		}
		if (!e.target.files) {
			setFormData((prevState) => ({
				...prevState,
				[e.target.id]: boolean ?? e.target.value,
			}));
		}
	}

	async function onSubmit(e) {
		e.preventDefault();
		setLoading(true);

		async function storeImage(image) {
			return new Promise((resolve, reject) => {
				const storage = getStorage();
				// console.log(image.name);
				const filename = `${auth.currentUser.uid}-${name.replace(
					/[^a-zA-Z0-9]/g,
					"-"
				)}`;
				const storageRef = ref(storage, filename);
				const uploadTask = uploadBytesResumable(storageRef, image);

				uploadTask.on(
					"state_changed",
					(snapshot) => {
						// Observe state change events such as progress, pause, and resume
						// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
						const progress =
							(snapshot.bytesTransferred / snapshot.totalBytes) *
							100;
						console.log("Upload is " + progress + "% done");
						switch (snapshot.state) {
							case "paused":
								console.log("Upload is paused");
								break;
							case "running":
								console.log("Upload is running");
								break;
							default:
								console.log("Unknown upload state");
								break;
						}
					},
					(error) => {
						// Handle unsuccessful uploads
						reject(error);
					},
					() => {
						// Handle successful uploads on complete
						// For instance, get the download URL: https://firebasestorage.googleapis.com/...
						getDownloadURL(uploadTask.snapshot.ref).then(
							(downloadURL) => {
								resolve(downloadURL);
							}
						);
					}
				);
			});
		}
		// console.log(image[0]);

		const imgUrl = await storeImage(image[0]);

		const formDataCopy = {
			...formData,
			imgUrl,
			timestamp: serverTimestamp(),
			userRef: auth.currentUser.uid,
			review: content,
		};
		delete formDataCopy.image;

		try {
			await addDoc(collection(db, "listings"), formDataCopy);
		} catch (error) {
			toast.error("Could not publish");
			console.log(error);
			return;
		} finally {
			setLoading(false);
		}
		toast.success("Published Successfully");
		navigate("/profile");
	}

	if (loading) {
		return <Spinner />;
	}

	return (
		<div>
			<div className="text-center text-2xl my-6 items-center justify-center font-bold">
				Create a Post
			</div>
			<form
				onSubmit={onSubmit}
				className="w-[90%] md:w-[70%] mx-auto items-center text-left uppercase font-semibold my-8"
			>
				<p>Album/Single</p>
				<div className="flex space-x-4">
					<button
						type="button"
						id="type"
						value="album"
						onClick={onChange}
						className={`w-full bg-gray-200 py-2 px-6 my-2 ml-0 uppercase rounded-md shadow-sm hover:shadow:md font-bold ${
							type === "album"
								? "bg-gray-700 text-gray-100 shadow-xl"
								: "bg-slate-500 text-gray-700"
						}`}
					>
						Album
						<BsCheckLg
							className={` text-gray-200 mx-1 ${
								type === "album" ? "inline" : "hidden"
							}`}
						/>
					</button>
					<button
						type="button"
						id="type"
						value="single"
						onClick={onChange}
						className={`w-full bg-gray-200 py-2 px-6 my-2 uppercase rounded-md shadow-sm hover:shadow:md font-bold ${
							type === "single"
								? "bg-gray-700 text-gray-100 shadow-xl"
								: "bg-slate-500 text-gray-700"
						}`}
					>
						Single
						<BsCheckLg
							className={` text-gray-200 mx-1 ${
								type === "single" ? "inline" : "hidden"
							}`}
						/>
					</button>
				</div>
				<p>Name</p>
				<input
					required
					onChange={onChange}
					className="w-full text-gray-800 font-semibold bg-gray-200 rounded-md my-2"
					type="text"
					id="name"
					value={name}
					maxLength="100"
					minLength="1"
					placeholder="Name of the Album/Single"
				/>
				<p>Artist(s)</p>
				<input
					required
					onChange={onChange}
					className="w-full text-gray-800 font-semibold bg-gray-200 rounded-md my-2"
					type="text"
					id="artist"
					value={artist}
					maxLength="100"
					placeholder="Artist(s) Name"
				/>
				<p>Review</p>
				<div className="text-gray-800 bg-gray-200 my-2 rounded-md p-1 normal-case">
					<CKEditor
						editor={ClassicEditor}
						data=""
						onBlur={(event, editor) => {
							console.log("Blur.", editor);
							setContent(editor.getData());
						}}
					/>
				</div>

				<div className="md:flex flex-1 w-full items-center">
					<p className="whitespace-nowrap mr-2">Year</p>
					<input
						required
						onChange={onChange}
						className="w-full md:w-1/4 text-gray-800 font-semibold bg-gray-200 rounded-md my-2"
						type="number"
						id="year"
						value={year}
						min="1000"
						max="2030"
						placeholder="Year of Release"
					/>
					<p className="whitespace-nowrap md:mx-2">Rating</p>
					<input
						required
						onChange={onChange}
						className="w-full md:w-1/4 text-gray-800 font-semibold bg-gray-200 rounded-md my-2"
						type="number"
						id="rating"
						value={rating}
						min="0"
						max="10"
						placeholder="Out of 10"
					/>
					<p className="whitespace-nowrap md:mx-2">Album Art</p>
					<input
						required
						onChange={onChange}
						className="w-full md:w-1/2 text-gray-800 font-semibold bg-gray-200 rounded-md my-2"
						type="file"
						id="image"
						accept=".jpg,.jpeg,.png"
					/>
				</div>
				<button
					type="submit"
					className="w-full font-bold bg-blue-600 hover:bg-blue-700 p-2 my-2 text-white rounded-md shadow-lg hover:shadow-xl uppercase"
				>
					Publish
				</button>
			</form>
		</div>
	);
}
